import React, { useState, useEffect } from "react";
import {
    Drawer,
    Button,
    Form,

} from "antd";
import {
    RightOutlined
} from "@ant-design/icons";


const InstancesDrawer = ({ visible, onClose }) => {
    const [form] = Form.useForm();
    return (
        <Drawer className={`DrawerBox`}
            title={"Description"}
            width={600}
            onClose={onClose}
            open={visible}           
        >
            <Form layout="vertical" form={form}>
                <div className="InstancesDrawerListValue">
                    <span>Value 1</span>
                    <p>Reduces and refines the appearance of pores for a radiant complexion.</p>
                </div>
                <div className="DrawerTableList InstancesDrawerList">
                    <h2>Product instances</h2>
                    <div
                        key={""}
                        className={`drawer-row`}
                        //  className={`drawer-row ${tabActive?.key === item.key ? 'active' : ''}`}


                        style={{ cursor: 'pointer' }}
                    >
                        <div className="drawer-info">
                            <div className="drawer-title">THE BETTER B NIACINAMIDE SERUM</div>
                            <div className="drawer-sub">SAP-12345662 – UK</div>
                        </div>
                        <RightOutlined />
                    </div>
                     <div
                        key={""}
                        className={`drawer-row`}      
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="drawer-info">
                            <div className="drawer-title">THE BETTER B NIACINAMIDE SERUM</div>
                            <div className="drawer-sub">SAP-12345662 – UK</div>
                        </div>
                        <RightOutlined />
                    </div>
                     <div
                        key={""}
                        className={`drawer-row`}                        
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="drawer-info">
                            <div className="drawer-title">THE BETTER B NIACINAMIDE SERUM</div>
                            <div className="drawer-sub">SAP-12345662 – UK</div>
                        </div>
                        <RightOutlined />
                    </div>
                     <div
                        key={""}
                        className={`drawer-row`}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="drawer-info">
                            <div className="drawer-title">THE BETTER B NIACINAMIDE SERUM</div>
                            <div className="drawer-sub">SAP-12345662 – UK</div>
                        </div>
                        <RightOutlined />
                    </div>
                     <div
                        key={""}
                        className={`drawer-row`}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="drawer-info">
                            <div className="drawer-title">THE BETTER B NIACINAMIDE SERUM</div>
                            <div className="drawer-sub">SAP-12345662 – UK</div>
                        </div>
                        <RightOutlined />
                    </div>
                </div>
            </Form>
        </Drawer>
    );
};

export default InstancesDrawer;
